import { render, staticRenderFns } from "./DriverComprehensive.vue?vue&type=template&id=057a1cb3&scoped=true&"
import script from "./DriverComprehensive.vue?vue&type=script&lang=js&"
export * from "./DriverComprehensive.vue?vue&type=script&lang=js&"
import style0 from "./DriverComprehensive.vue?vue&type=style&index=0&id=057a1cb3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a1cb3",
  null
  
)

export default component.exports